export const getType = (e: any) => {
    return Object.prototype.toString.call(e)
}

// object
export const isObject = (e: any) => getType(e) === '[object Object]'

// event
export const isEvent = (e: any) => isObject(e) && e.target

// promise
export const isPromise = (e: any) => getType(e) === '[object Promise]'
